import CityResource from "./city.resource";

const cityModule = angular
  .module("app.resources.city", [])
  .service("City", CityResource);

export default cityModule;



// WEBPACK FOOTER //
// ./src/resources/city/city.module.js